export default function Location() {
  return (
    <section id="localisation" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Notre Localisation
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Basés à Chevilly-Larue, nous sommes stratégiquement positionnés pour servir toute la région Île-de-France
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-2xl shadow-lg border border-emerald-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                Adresse
              </h3>
              <div className="space-y-3 text-gray-700 text-lg">
                <p className="font-semibold">GO BACK LOGISTIQUE</p>
                <p>102 Avenue des Maraichers</p>
                <p>Batiment C1</p>
                <p>94550 Chevilly-Larue</p>
                <p>France</p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-2xl shadow-lg border border-emerald-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
                Horaires d'Ouverture
              </h3>
              <div className="space-y-3 text-gray-700">
                <div className="flex justify-between items-center py-2 border-b border-emerald-100">
                  <span className="font-semibold">Disponibilité</span>
                  <span className="text-emerald-600 font-bold">24/24 - 7/7</span>
                </div>
                <p className="text-sm text-gray-600 mt-4 bg-emerald-50 p-4 rounded-lg">
                  <i className="ri-information-line text-emerald-600 mr-2"></i>
                  Notre service est disponible en continu pour répondre à tous vos besoins en logistique florale, à tout moment.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white p-8 rounded-2xl shadow-lg border border-emerald-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line text-2xl text-white"></i>
                </div>
                Contact
              </h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <i className="ri-phone-fill text-emerald-600 text-xl"></i>
                  <a href="tel:0606702620" className="text-lg text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                    06 06 70 26 20
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-fill text-emerald-600 text-xl"></i>
                  <a href="mailto:gobacklogistique@gmail.com" className="text-lg text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                    gobacklogistique@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="h-[600px] rounded-2xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2629.5!2d2.3500!3d48.7667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDjCsDQ2JzAwLjEiTiAywrAyMScwMC4wIkU!5e0!3m2!1sfr!2sfr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localisation GO BACK LOGISTIQUE"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}